import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { CSidebar, CSidebarBrand } from '@coreui/react'
import BpLogo from '../components/BpLogo'

// Custom nav rendering: sections + emoji icons, no CoreUI icon dependency.
const NAV = [
  {
    title: 'Store',
    items: [
      { to: '/dashboard', label: 'Overview', icon: '📊', end: true },
      { to: '/dashboard/menu-products', label: 'Products', icon: '📦' },
      { to: '/dashboard/orders', label: 'Orders', icon: '🧾' },
      { to: '/dashboard/messages', label: 'Messages', icon: '💬' },
      { to: '/dashboard/deals', label: 'Deals', icon: '🏷️' },
      { to: '/dashboard/category', label: 'Categories', icon: '🗂️' },
    ],
  },
  {
    title: 'Growth',
    items: [
      { to: '/dashboard/upgrade', label: 'Subscription', icon: '💎' },
      { to: '/dashboard/pre-order', label: 'Analytics', icon: '📈' },
      { to: '/dashboard/reviews', label: 'Reviews', icon: '⭐' },
    ],
  },
  {
    title: 'Profile',
    items: [
      { to: '/dashboard/edit', label: 'Edit Profile', icon: '⚙️' },
      { to: '/dashboard/gallery', label: 'Photos', icon: '🖼️' },
      { to: '/dashboard/publicProfile', label: 'Public Page', icon: '👁️' },
      { to: '/dashboard/invoice', label: 'Invoices', icon: '📄' },
    ],
  },
]

const Sidebar = () => {
  const dispatch = useDispatch()
  const show = useSelector(state => state.sidebarShow)
  return (
    <CSidebar
      position="fixed"
      visible={show !== false}
      onVisibleChange={(val) => dispatch({ type: 'set', sidebarShow: val })}
      className="bp-sidebar"
    >
      <CSidebarBrand className="d-md-down-none">
        <BpLogo size={24} />
      </CSidebarBrand>
      <nav className="bp-side-nav">
        {NAV.map(section => (
          <div className="bp-side-sec" key={section.title}>
            <span className="bp-side-title">{section.title}</span>
            {section.items.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `bp-side-link ${isActive ? 'active' : ''}`}>
                <i aria-hidden="true">{item.icon}</i>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <a className="bp-side-store" href="/">
        <i aria-hidden="true">🛍️</i> View your storefront ↗
      </a>
    </CSidebar>
  )
}

export default React.memo(Sidebar)
